
import { MutationTree } from "vuex";
import types from "./mutation-types";
import { State } from "./state";

export default {
  [types.INIT_NEW_SETTINGS_FOR_SCHEUDLE](state: State) {
    state.scheduler = state.schedulerInitData;
  },  
  [types.CREATE_SCHEDULER_SUCCESS](state: State, response:any) {
    state.schedulers = response;
  },  
  [types.SCHEDULER_FAIL](state: State, error: any) {
    state.error = error.error;
  },
  [types.SET_SCHEDULER](state: State, scheduler: any) {
    // Update scheduler with the payload coming from actions/components.
    // This allows fields like `dApptNotification`, `days`, dates, etc.
    // to be persisted correctly instead of always resetting to defaults.
    state.scheduler = scheduler;
  },
  [types.LIST_SCHEDULER_SUCCESS](state: State, response:any) {
    state.schedulers = response;
  },
} as MutationTree<State>;